<div class="block block-rounded block-themed">
  <div class="block-header bg-gd-primary">
    <h3 class="block-title">Google Maps</h3>
  </div>
  <agm-map *ngIf="housing != null" [latitude]="housing.location.latitude" [longitude]="housing.location.longitude" [zoom]="18">
    <agm-marker [latitude]="housing.location.latitude" [longitude]="housing.location.longitude"></agm-marker>
  </agm-map>
</div>
